import React from 'react';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import { EventContainer } from '../EventContainer/EventContainer';

export const AppContainer = () => {
  return (
    <IntlProvider>
      <Provider store={store}>
        <div className="flex flex-wrap mt-4 gap-[64px] md:gap-[100px]">
          <EventContainer />
        </div>
      </Provider>
    </IntlProvider>
  );
};
